import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';

const LogoutIcon = (props) => (
  <SvgIcon viewBox="0 0 24 18" {...props}>
    <path fill={props.color} d="M15 18H5.253a.75.75 0 0 1-.657-.39L.09 9.36a.752.752 0 0 1 0-.719L4.596.391A.75.75 0 0 1 5.255 0H15a.75.75 0 0 1 .659.391l2.626 4.814a.751.751 0 0 1-1.317.719L14.555 1.5H5.7L1.605 9 5.7 16.5h8.855l2.413-4.423a.75.75 0 1 1 1.317.719l-2.626 4.814a.753.753 0 0 1-.66.39z" />
    <path fill={props.color} d="M11.624 14.25a.744.744 0 0 1-.53-.22l-4.5-4.5a.75.75 0 0 1 0-1.061l4.5-4.5a.75.75 0 1 1 1.062 1.061L8.185 9l3.97 3.97a.75.75 0 0 1-.532 1.28z" />
    <path fill={props.color} d="M23.25 9.75H7.125a.75.75 0 0 1 0-1.5H23.25a.75.75 0 0 1 0 1.5z" />
  </SvgIcon>
);

export default LogoutIcon;



// WEBPACK FOOTER //
// ./src/icons/menu/LogoutIcon.jsx